import OptionGroup, { Option } from 'types/ProductOptionGroup';
import { Product } from 'types/models/Product';
import { VariantAttributeValue } from 'types/models/VariantAttributeValue';
import checkIfAttributeValueMatch from 'utils/checkIfAttributeValueMatch';

export const getFilteredOptionGroups = (
  groups: OptionGroup[],
  comparator: (option: Option) => boolean
): OptionGroup[] =>
  groups.map((group) => ({
    ...group,
    options: group.options.filter(comparator),
  }));

export const getVariantsWithAttributeValue = (
  productVariants: Product['variants'],
  variantAttributeValue?: VariantAttributeValue
): number[] =>
  productVariants
    ?.filter(
      (variant) =>
        variant.variantsAttributesValues?.find((attributeValue) =>
          checkIfAttributeValueMatch(attributeValue, variantAttributeValue)
        )
    )
    .map(({ id: matchedVariantId }) => matchedVariantId) || [];
